// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"8bb90747","106":"be1fd3ca","245":"08a1068e","247":"9f36963a","253":"e7725466","453":"8ab44547","479":"eca3f33d","545":"4ee94de5","672":"796cb61c","924":"137840b1"}[chunkId] + ".chunk.js";
};